<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="100px" inline>
    <div class="flex-item">
      <el-form-item label="用户名" prop="userName">
        <el-input v-model="form.userName" :readonly="isEdit" />
      </el-form-item>
      <el-form-item label="密码" prop="fPassword">
        <el-input v-model="form.fPassword" show-password />
      </el-form-item>
      <el-form-item label="用户类型" style="width:100%">
        <el-select v-model="form.fType">
          <el-option value="普通用户" />
          <el-option value="管理员">管理员</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色">
        <el-select-ex
          v-model="form.roles"
          multiple
          collapse-tags
          clearable
          url="SystemApplication/User/UserNoRoleEntry"
          label-field="fName"
          value-field="fid"
        />
      </el-form-item>
    </div>
    <div class="flex-item">
      <el-form-item label="允许并发登录" style="width:100%">
        <el-radio-group v-model="form.fConcurrent">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="中文名" prop="fName">
        <el-input v-model="form.fName" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="form.fState" style="width:100%">
          <el-option value="正常">正常</el-option>
          <el-option value="禁用">禁用</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="照片">
        <!-- <el-input v-model="form.pictureUrl"></el-input> -->
        <template v-if="imgSrc">
          <img width="100" height="100" :src="imgSrc">
          <el-button size="small" type="text" style="margin-left:10px" @click="_import">更换</el-button>
        </template>
        <template v-else>
          <el-button size="small" icon="el-icon-plus" circle @click="_import" />
        </template>
        <input ref="fileSel" type="file" style="display:none;" accept="image/jpeg, image/jpg, image/png">
      </el-form-item>
    </div>
    <p
      style="font-size: 18px;
    color: #303133;border-bottom:1px solid #ccc;height:35px"
    >用户信息</p>
    <div class="flex-item">
      <el-form-item label="员工编号">
        <el-input v-model="form.fNumber" />
      </el-form-item>
      <el-form-item label="英文名">
        <el-input v-model="form.fEnglishName" />
      </el-form-item>

      <el-form-item label="部门" prop="fDeptId">
        <el-select-tree
          v-model="form.fDeptId"
          url="SystemApplication/Dept/DeptTree"
          node-key="fDeptID"
          panel-width="300px"
        />
      </el-form-item>
      <el-form-item label="区域" prop="fRegionID">
        <el-select-ex
          v-model="form.fRegionID"
          url="BasicInformation/Region/RegionEntry"
          label-field="fName"
          value-field="fRegionID"
        />
      </el-form-item>
    </div>
    <div class="flex-item">
      <el-form-item label="性别">
        <el-select v-model="form.fGender" style="width:100%">
          <el-option value="男">男</el-option>
          <el-option value="女">女</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出生日期">
        <el-date-picker v-model="form.fBirthday" type="date" value-format="yyyy-MM-dd" />
      </el-form-item>
      <el-form-item label="职称">
        <el-select-ex
          v-model="form.fTitleID"
          clearable
          url="SystemApplication/Title/TitleEntry"
          label-field="fName"
          value-field="fTitleID"
        />
      </el-form-item>
      <el-form-item label="身份证">
        <el-input v-model="form.fIdentityCard" />
      </el-form-item>
    </div>
    <div class="flex-item">
      <el-form-item label="家庭电话">
        <el-input v-model="form.fHomePhone" />
      </el-form-item>
      <el-form-item label="手机号码">
        <el-input v-model="form.fMobilePhone" />
      </el-form-item>
      <el-form-item label="公司邮件地址">
        <el-input v-model="form.fCompanyEmail" />
      </el-form-item>
      <el-form-item label="邮件地址">
        <el-input v-model="form.fEmail" />
      </el-form-item>
    </div>
    <div class="flex-item">
      <el-form-item label="分机号码">
        <el-input v-model="form.fExtension" />
      </el-form-item>
      <el-form-item label="到职日期">
        <el-date-picker v-model="form.fHireDate" type="date" value-format="yyyy-MM-dd" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.fDes" />
      </el-form-item>

      <el-form-item label="区域商务助理" style="width:100%">
        <el-radio-group v-model="form.fIsRegionAssistant">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import md5 from 'md5'

export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        userName: [{ required: true, message: '必填项', trigger: 'change' }],
        fPassword: [{ required: true, message: '必填项', trigger: 'change' }],
        fName: [{ required: true, message: '必填项', trigger: 'change' }],
        fDeptId: [{ required: true, message: '必填项', trigger: 'change' }],
        fRegionID: [{ required: true, message: '必填项', trigger: 'change' }]
      },
      imgSrc: null,
      imgFile: null,
      oldPW: null
    }
  },
  computed: {
    isEdit: function() {
      return !!this.form.userID
    }
  },
  mounted: function() {
    setTimeout(() => {
      // console.log(this.form.pictureUrl, this.form.fPassword)
      this.imgSrc = this.form.pictureUrl
      this.oldPW = this.form.fPassword
    }, 10)
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate(valid => {
        if (valid) {
          var user = this.form.userName
          var pw = this.form.fPassword
          if (pw != this.oldPW) {
            pw = md5(user + pw + user).toUpperCase()
          }
          var data = Object.assign({}, this.form)
          data.fPassword = pw
          onValid({
            data: data,
            file: this.imgFile
          })
        } else {
          return false
        }
      })
    },
    _import: function() {
      const _this = this
      var fileSel = this.$refs.fileSel
      fileSel.onchange = () => {
        setTimeout(() => {
          fileSel.value = null
        }, 100)
        if (!fileSel.files.length) return
        var file = fileSel.files[0]
        _this.imgFile = file

        var reader = new FileReader()
        reader.onload = function(e) {
          _this.imgSrc = e.target.result
        }
        reader.readAsDataURL(file)
      }
      fileSel.click()
    }
  }
}
</script>

<style lang="less" scoped>
  .flex-item {
    display: flex;
    width:95%;
    & > .el-form-item {
      flex: 0 0 25%;
      display: flex;

      & .el-input, &.el-select {
        width: 100%;
      }
    }
    .el-form-item__error{
      position: absolute;
      top:0%;
    }
  }
</style>
